export default __webpack_public_path__ + "static/media/m_engineering_card08_2.f233d57b.png";